<template>
  <div class="events-feed events-feed--small">
    <results :has-carousel=hasCarousel></results>
  </div>
</template>

<script>
import Results from '../components/elementEvents.vue'
export default {
  components: {
    Results
  },
  props: {
    hasCarousel: {
      type: Boolean,
      required: true
    },
  }
}
</script>
./eventDetail.vue
